import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
import StoreLayout from "./components/layout/StoreLayout";
import EventListPage from "./pages/EventListPage";
import PublicMarketplacePage from "./pages/PublicMarketplacePage";
import PlatformContactPage from "./pages/PlatformContactPage";

const isRootDomain =
    import.meta.env.VITE_IS_MARKETPLACE === "true" ||
    (typeof window !== "undefined" &&
    /^(www\.)?pulseticket\.es$/.test(window.location.hostname));
import SectorMapPage from "./pages/SectorMapPage";
import SeatSelectionPage from "./pages/SeatSelectionPage";
import GeneralAdmissionPage from "./pages/GeneralAdmissionPage";
import CartReviewPage from "./pages/CartReviewPage";
import CheckoutPage from "./pages/CheckoutPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import RecoverTicketsPage from "./pages/RecoverTicketsPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import FaqPage from "./pages/FaqPage";
import MessageCenter from "./components/ui/MessageCenter";
import ContactPage from "./pages/ContactPage";
import CookieBanner from "./components/CookieBanner";

function App() {
  if (isRootDomain) {
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/contact" element={<PlatformContactPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="*" element={<PublicMarketplacePage />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter basename={import.meta.env.PROD ? '/tienda' : ''}>
      <ScrollToTop />
      <Routes>
        <Route element={<StoreLayout />}>
          <Route path="/" element={<EventListPage />} />
          <Route path="/events/:eventId" element={<SectorMapPage />} />
          <Route path="/events/:eventId/general-admission" element={<GeneralAdmissionPage />} />
          <Route path="/events/:eventId/seats/:sectionId" element={<SeatSelectionPage />} />
          <Route path="/cart-review" element={<CartReviewPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/confirmation/:orderNumber" element={<ConfirmationPage />} />
          <Route path="/recover-tickets" element={<RecoverTicketsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/faq" element={<FaqPage />} />
        </Route>
      </Routes>
      <MessageCenter />
      <CookieBanner />
    </BrowserRouter>
  );
}


export default App;
